// extracted by mini-css-extract-plugin
export default {"container":"HelpAndSupport_container__UJ9wT","header":"HelpAndSupport_header__fHCgX"};